import { useState, useEffect } from "react";
import { BookOpen, Loader2 } from "lucide-react";

// Robust image with loading shimmer, one silent retry, and a graceful fallback.
export default function SmartImage({ src, alt = "", className = "", imgClassName = "", testId }) {
  const [status, setStatus] = useState("loading"); // loading | loaded | error
  const [tick, setTick] = useState(0);

  useEffect(() => {
    setStatus("loading");
    setTick(0);
  }, [src]);

  if (!src || status === "error") {
    return (
      <div data-testid={testId} className={`flex items-center justify-center bg-muted ${className}`}>
        <BookOpen className="h-8 w-8 text-muted-foreground/60" />
      </div>
    );
  }

  const bust = tick > 0 ? `${src}${src.includes("?") ? "&" : "?"}r=${tick}` : src;

  return (
    <div className={`relative overflow-hidden bg-muted ${className}`}>
      {status === "loading" && (
        <div className="absolute inset-0 flex animate-pulse items-center justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-primary/70" />
        </div>
      )}
      <img
        data-testid={testId}
        src={bust}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setStatus("loaded")}
        onError={() => {
          if (tick < 1) setTick(1);
          else setStatus("error");
        }}
        className={`h-full w-full transition-opacity duration-500 ${status === "loaded" ? "opacity-100" : "opacity-0"} ${imgClassName}`}
      />
    </div>
  );
}
